<template>
  <textarea class="input-100 mb10" v-model="model" :disabled="disabled" />
</template>
<script>
export default {
  props: ['storeName', 'modelName', 'mutationName', 'disabled'],
  computed: {
    model: {
      get() {
        return this.$store.state[this.storeName][this.modelName]
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: newValue,
        })
      },
    },
  },
}
</script>
